var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import Rupee from "@frameworks/shared-library/assets/images/features/Markets/NCD/order-book-refund-flow.svg";
import InfoAlert from "@frameworks/NCD/Components/InfoAlert";
import SelectionCard from "@frameworks/NCD/Components/SelectionCard";
import actions from "@redux/feature/Markets/NCD/actions/OrderBookActions";
var InitiateRefundSelect = function () {
    var selectedRefundType = useSelector(function (state) { return state.markets.Otc.orderBookReducer; }).selectedRefundType;
    var cActions = new actions();
    var _a = __read(useState(true), 2), alert = _a[0], setAlert = _a[1];
    var containerRef = useRef(null);
    var contentRef = useRef(null);
    var _b = __read(useState(false), 2), showImage = _b[0], setShowImage = _b[1];
    var checkRemainingSpace = function () {
        var container = containerRef.current;
        var content = contentRef.current;
        if (!container || !content)
            return;
        var containerHeight = container.offsetHeight;
        var contentHeight = content.scrollHeight;
        var remainingSpace = containerHeight - contentHeight;
        setShowImage(remainingSpace >= 200);
    };
    useEffect(function () {
        checkRemainingSpace();
        window.addEventListener("resize", checkRemainingSpace);
        return function () { return window.removeEventListener("resize", checkRemainingSpace); };
    }, [showImage]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "d-flex flex-column gap-20 position-relative h-100", ref: containerRef },
            React.createElement("div", { className: "d-flex flex-column gap-20", ref: contentRef },
                React.createElement("h2", { className: "txt-midnight-blue-shade2 DMSansNormal_20_400 mb-0" }, "Initiate Refund"),
                React.createElement("div", { className: "d-flex flex-column gap-16" },
                    React.createElement("h4", { className: "txt-grey-shade1 DMSanM_14_500 " }, "Choose a refund reason"),
                    alert && (React.createElement(InfoAlert, { title: "Compute and confirm the refund amount with Client before proceeding.", className: "alert-container", cancelBtnCallback: function () { return setAlert(false); } })),
                    React.createElement(SelectionCard, { selectedId: selectedRefundType === null || selectedRefundType === void 0 ? void 0 : selectedRefundType.id, onSelect: function (selected) {
                            cActions.updateSelectedRefundType({
                                id: selected === null || selected === void 0 ? void 0 : selected.id,
                                name: selected === null || selected === void 0 ? void 0 : selected.name,
                                refund_description: selected === null || selected === void 0 ? void 0 : selected.refund_description,
                            });
                        } }))),
            showImage && (React.createElement("img", { src: Rupee, className: "position-absolute end-0", alt: "Product Illustration", style: { bottom: "-23px" } })))));
};
export default InitiateRefundSelect;
